/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export * from './InfoTag.component';
export * from './InfoTag.utils';
